import { env } from '@repo/environment';
import { RouteNames } from '@repo/routes';
export function handleForbiddenRedirect(errorMessage, errorCode) {
    sessionStorage.setItem('axiosErrorMessage', errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Access Denied');
    sessionStorage.setItem('axiosError', errorCode !== null && errorCode !== void 0 ? errorCode : '');
    const authWorkerUrl = new URL(RouteNames.FORBIDDEN, env.PUBLIC_AUTH_API_BASE_URL).toString();
    window.location.href = authWorkerUrl;
}
